module.exports = __webpack_public_path__ + "static/img/title2.e6c12a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title2.jpg
// module id = DI+7
// module chunks = 0